import BaseControlTypeConst from "./BaseControlTypeConst"

export default class ColumnTypeConst extends BaseControlTypeConst {
    static FIELD='field'
    static HEADER='header'
    static SORTABLE='sortable'

}
